import { FC } from "react";

interface RawHTMLProps extends React.HTMLAttributes<HTMLSpanElement> {
  html: string;
  className?: string;
}

const RawHTML: FC<RawHTMLProps> = ({ html, className }, props) => {
  return (
    <span
      className={`raw-html ${className}`}
      dangerouslySetInnerHTML={{ __html: html }}
      {...props}
    />
  );
};

export default RawHTML;
